module.exports = __webpack_public_path__ + "img/blcn.99917027.svg";